import React, { Children, lazy } from 'react';
import { motion } from 'framer-motion';
import { Heart, Sun, Moon, Sparkles, Star, Eye, Cloud, Flame, Users, Compass, Baby } from 'lucide-react';
export function EbookContents() {
  const rituals = [{
    icon: <Users className="w-6 h-6" data-id="element-51" />,
    title: 'Ceremonias de Unión',
    desc: 'Aprende a crear y dirigir ceremonias de unión profundas y personalizadas.'
  }, {
    icon: <Baby className="w-6 h-6" data-id="element-52" />,
    title: 'Ceremonias de Bienvenida al mundo y bendición de nombre',
    desc: 'Honra la llegada de una nueva vida con rituales llenos de amor y significado.'
  }, {
    icon: <Sun className="w-6 h-6" data-id="element-53" />,
    title: 'Ritual de cumpleaños',
    desc: 'Transforma tu cumpleaños en un momento de conciencia y renovación.'
  }, {
    icon: <Compass className="w-6 h-6" data-id="element-54" />,
    title: 'Ritual para Transiciones difíciles',
    desc: 'Acompaña los cambios más retadores de tu vida con contención y propósito.'
  }, {
    icon: <Moon className="w-6 h-6" data-id="element-55" />,
    title: 'Ritual para Cierre de ciclos',
    desc: 'Ideal para terminar relaciones, proyectos o etapas de vida.'
  }, {
    icon: <Star className="w-6 h-6" data-id="element-56" />,
    title: 'Ritual para Cierre de año e inicio de uno nuevo',
    desc: 'Un proceso poderoso con construcción de mapa de sueños para iniciar con claridad.'
  }, {
    icon: <Sparkles className="w-6 h-6" data-id="element-57" />,
    title: 'Ritual para Atraer más abundancia',
    desc: 'Para trabajar tu energía de merecimiento y apertura.'
  }, {
    icon: <Eye className="w-6 h-6" data-id="element-58" />,
    title: 'Ritual para Desarrollar tu intuición',
    desc: 'Conecta con tu guía interior de forma profunda.'
  }, {
    icon: <Heart className="w-6 h-6" data-id="element-59" />,
    title: 'Ritual para Construir y potenciar tu amor propio',
    desc: 'Reconecta contigo desde una perspectiva amorosa y profunda.'
  }, {
    icon: <Cloud className="w-6 h-6" data-id="element-60" />,
    title: 'Rituales para atravesar un duelo',
    desc: 'Diseñado para acompañar procesos de pérdida con amor y contención.'
  }, {
    icon: <Flame className="w-6 h-6" data-id="element-61" />,
    title: 'Rituales de pareja para fortalecer el vínculo',
    desc: 'Fortalece la conexión con tu pareja a través de rituales compartidos.'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.06
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.4
      }
    }
  };
  return <section className="bg-cream-light py-14 md:py-20" data-id="element-62">
      <div className="max-w-6xl mx-auto px-6" data-id="element-63">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto mb-6 rounded-sm overflow-hidden shadow-lg" data-id="element-64">
          <img src="https://cdn.magicpatterns.com/uploads/c2aJZ92n5WeMj8AfBhxfMw/IMG_8427.png" alt="Mujer leyendo el eBook con velas y cristales" className="w-full h-auto object-cover" loading="lazy" data-id="element-65" />
        </motion.div>

        <div className="text-center max-w-3xl mx-auto mb-10 space-y-3" data-id="element-66">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-playfair font-bold text-brown-dark" data-id="element-67">
            ¿Qué hay dentro del eBook?
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl font-playfair italic text-gold-dark" data-id="element-68">
            El Arte de Crear Espacios Sagrados
          </motion.p>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="font-lora text-brown-light text-lg" data-id="element-69">
            Una guía completa para aprender a crear y dirigir rituales con
            profundidad. Dentro encontrarás:
          </motion.p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-10" data-id="element-70">
          {rituals.map((ritual, idx) => <motion.div key={idx} variants={itemVariants} className="bg-cream-dark p-6 rounded-sm border border-gold-main/20 hover:border-gold-main/50 transition-colors" data-id="element-71">
              <div className="text-gold-main mb-3" data-id="element-72">{ritual.icon}</div>
              <h3 className="text-lg font-playfair font-semibold text-brown-dark mb-1.5" data-id="element-73">
                {ritual.title}
              </h3>
              <p className="font-lora text-brown-light text-sm" data-id="element-74">
                {ritual.desc}
              </p>
            </motion.div>)}
        </motion.div>

        <div className="flex flex-col lg:flex-row gap-10 items-center max-w-5xl mx-auto mt-10" data-id="element-75">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="w-full lg:w-1/2" data-id="element-76">
            <img src="https://cdn.magicpatterns.com/uploads/7Y4rqEXjMsUtDVUfAzvtQc/PRODUCTO.png" alt="Ebook en diferentes dispositivos" className="w-full h-auto drop-shadow-xl" loading="lazy" data-id="element-77" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="w-full lg:w-1/2 space-y-4" data-id="element-78">
            <h3 className="text-2xl md:text-3xl font-playfair font-bold text-brown-dark" data-id="element-79">
              Todo explicado paso a paso
            </h3>
            <p className="font-lora text-brown-light text-lg" data-id="element-80">
              Cada ritual incluye una guía teórica para entender la raíz y una
              guía práctica para que puedas hacerlo en casa, sola, en pareja o
              en grupo.
            </p>
            <p className="font-lora font-medium text-gold-dark italic pt-2" data-id="element-81">
              Más de 200 páginas de contenido profundo y amoroso.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}